import { render, staticRenderFns } from "./ExpenseTypeMenu.vue?vue&type=template&id=2d0d267e&scoped=true&"
import script from "./ExpenseTypeMenu.vue?vue&type=script&lang=js&"
export * from "./ExpenseTypeMenu.vue?vue&type=script&lang=js&"
import style0 from "./ExpenseTypeMenu.vue?vue&type=style&index=0&id=2d0d267e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0d267e",
  null
  
)

export default component.exports